import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SpinLoader } from 'app/components';
import { routeConstants } from 'app/routes/route-constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { CodetableListItems } from 'app/area/codetable/list/list-items';
import { UserGroupCodeModal } from './user-group-code-modal';
import { ResizeWrapper } from 'app/components/resize-wrapper';
import styles from './user-group-list-content.scss';

const buttonComponent = ({ onClick, children }) => {
  return <div className="dropdown-item" onClick={onClick}>
    {children}
  </div>;
};

interface UserGroupListContentProps extends CodetableListComponentProps {
  children?: React.ReactNode;
}

export class UserGroupListContent extends Component<UserGroupListContentProps> {
  private addLinkFactory = (label: string, breadcrumbs: number[], parentId: number, duplicateId?: number) => {
    if (isDefinedIncludingZero(duplicateId)) {
      return <Link to={routeConstants.codetableAdministrationDuplicateCodeFor(breadcrumbs, duplicateId)}
        className="dropdown-item">
        {label}
      </Link>;
    }

    const { codetableId, codetableOptions, loadCodetableOptions, translation } = this.props;

    return <UserGroupCodeModal
      label={label}
      codetableId={codetableId}
      breadcrumbs={breadcrumbs}
      parentId={parentId}
      codetableOptions={codetableOptions}
      loadCodetableOptions={loadCodetableOptions}
      ButtonComponent={buttonComponent}
      translation={translation}
    />;
  };

  public render() {
    const { isHierarchy, isHierarchyMode, shouldRenderList, shouldRenderSpinLoader, hasCategoryMetadata,
      hasSelectedCategory, breadcrumbs, codetableId, codeId, codeListBranch, rootBranch, codeAccessConfiguration,
      codeListBranchState, metadata, mergeCode, options, validation, itemAccess, fetchingItemAccess, children, translation,
      updateMergeCode, loadFromParent, reloadCodeItems, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess,
      loadOptions, updateCodeParent, updateConfirmPrompt, resetValidation
    } = this.props;

    return <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
      <div className={styles.codetableListHolder}>
        <div className={styles.numberOfResults}>
          {(!hasCategoryMetadata || (hasCategoryMetadata && hasSelectedCategory))
            && <NumberOfResults
              rootBranch={rootBranch}
              translation={this.props.translation} />}
        </div>

        {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
        {
          shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>
            {children}
            <div className={styles.listItems}>
              <ResizeWrapper>
                <CodetableListItems
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codetableName={metadata?.label}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  reloadCodeItems={reloadCodeItems}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={this.addLinkFactory}
                  validation={validation}
                  resetValidation={resetValidation}
                  metadata={metadata}
                  mergeCode={mergeCode}
                  updateMergeCode={updateMergeCode}
                  updateCodeParent={isHierarchy && updateCodeParent}
                  updateConfirmPrompt={updateConfirmPrompt}
                  options={options}
                  loadOptions={loadOptions} />
              </ResizeWrapper>
            </div>
          </div>
        }
      </div>
    </div>;
  }
}
